import React from 'react';
import { MediaData } from '~admin/model/media-data';
import { MediaPickerSearch } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-search.component';
import { MediaPickerUpload } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-upload.component';
import { MediaType } from '~client/model/media-type';

interface Props {
  mode: MediaPickerMode;
  enableUpload: boolean;
  mediaType: MediaType;
  onCancel?: VoidFunction;
  onMediaSelected?: (media: MediaData) => void;
}

export enum MediaPickerMode {
  SEARCH = 'SEARCH',
  UPLOAD = 'UPLOAD',
}

export const MediaPickerModeInner: React.FunctionComponent<Props> = ({
  mode,
  enableUpload,
  mediaType,
  onCancel,
  onMediaSelected,
}) => {
  switch (mode) {
    case MediaPickerMode.UPLOAD:
      return (
        enableUpload && <MediaPickerUpload mediaType={mediaType} onFileUploaded={onMediaSelected} />
      );
    case MediaPickerMode.SEARCH:
    default:
      return (
        <MediaPickerSearch
          mediaType={mediaType}
          onCancel={onCancel}
          onMediaSelected={onMediaSelected}
        />
      );
  }
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/media/media-overlay/media-picker-mode-inner.component.tsx